import React, { useState } from "react";
import PropTypes from "prop-types";

// Material
import { makeStyles } from "@material-ui/core/styles";

// Config
import colors from "src/config/colors";
import useTranslate from "src/hooks/useTranslate";

// Assets
import perpetratorIcon from "src/assets/icons/icon-perpetrator.svg";

// Components
import Button from "src/components/Button";
import AddMediaPerpetrator from "src/components/AddMediaPerpetrator";
import Text from "src/components/Text";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column"
  },
  card: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    backgroundColor: colors.wildLand,
    borderRadius: theme.shape.borderRadius,
    borderColor: colors.mystic,
    gap: 30,
    padding: "30px 48px",
    marginBottom: 12
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    justifyContent: "flex-start"
  },
  icon: {},
  title: {
    color: colors.doveGray
  },
  addButtonQuick: {
    marginLeft: "auto",
    color: colors.dodgerBlue,
    textTransform: "uppercase"
  }
}));

const AddPerpetratorWrapper = ({ open }) => {
  const classes = useStyles();
  const getText = useTranslate();
  const [isAdding, setAdding] = useState(open);

  const handleClick = () => setAdding(true);

  return (
    <div className={classes.root}>
      {isAdding ? (
        <>
          <div className={classes.card}>
            <img src={perpetratorIcon} className={classes.icon} alt="" />
            <div className={classes.cardContent}>
              <Text
                className={classes.title}
                type="heading6"
                text="mediaPage.encourageCard.title"
              />
              <Text
                type="contentLabel2"
                text="caseIncidentsPage.perpetratorImageCard.description"
              />
              <div>
                <AddMediaPerpetrator
                  text="mediaPage.encourageCard.button"
                  buttonProps={{
                    variant: "outlined",
                    color: "default"
                  }}
                />
              </div>
            </div>
          </div>
          <Text type="body2" text="mediaPage.encourageCard.description" />
        </>
      ) : (
        <Button
          color="primary"
          disableElevation
          regular
          className={classes.addButtonQuick}
          onClick={handleClick}
        >
          {getText("caseIncidentsPage.perpetratorsAddButton")}
        </Button>
      )}
    </div>
  );
};

AddPerpetratorWrapper.propTypes = {
  open: PropTypes.bool.isRequired
};

export default AddPerpetratorWrapper;
